/// <reference types="@angular/localize" />

import { APP_INITIALIZER, enableProdMode, ErrorHandler, importProvidersFrom } from '@angular/core';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { LicenseServiceGrid, RoleTemplateServiceGrid } from '@myapp/features/admin/services';
import { AuthorizationService, ConfirmationDialogHtmlPaneService, ConfirmationDialogService, UiWindowService, UserService } from '@myapp/modules/fwcore/services';
import { NgbAlertModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { OktaAuthGuard, OktaAuthModule, OktaCallbackComponent, OKTA_CONFIG } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { NotificationService } from '@progress/kendo-angular-notification';
import { AppComponent } from './app/app.component';
import { FwcoreModule } from './app/modules/fwcore/fwcore.module';
import { ApplicationInsightsErrorHandler } from './app/modules/fwcore/handlers';
import { HomePageComponent, LoginComponent, PageNoLicenseComponent, PageNotAuthorizedComponent, PageNotFoundComponent } from './app/modules/fwcore/pages';
import { environment } from './environments/environment';
import { ErrorIntercept } from './interceptors/error.interceptor';
import { InterceptorDateHttp } from './interceptors/interceptorDateHttp';
import { LoaderInterceptor } from './interceptors/interceptorLoader';

import { initSettingsTabs } from './app/modules/fwcore/components/user-settings/user-settings.func';
import { provideLottieOptions } from 'ngx-lottie'

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

  // Get okta settings before bootstrapping
  fetch('/assets/configuration/appconfig.json')
    .then(response => response.json())
    .then(config => {

      const providersConfig = [
        { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
        { provide: 'CONFIG_SETTINGS', useValue: config }
      ];

      if (environment.production) {
        enableProdMode();
      }

      bootstrapApplication(AppComponent
        , {
          providers: [
            importProvidersFrom(
              BrowserModule
              , OktaAuthModule
              , NgbModule
              , NgbAlertModule
              , FwcoreModule
              , NgIdleKeepaliveModule.forRoot()
            )
            , providersConfig
            , {
              provide: OKTA_CONFIG, useFactory: (config: 'CONFIG_SETTINGS') => {
                const oktaSettings = config[<any>'okta'];
                const oktaConfig = {
                  issuer: oktaSettings[<any>'issuer']
                  , redirectUri: oktaSettings[<any>'redirectUri']
                  , postLogoutRedirectUri: oktaSettings[<any>'postLogoutRedirectUri']
                  , clientId: oktaSettings[<any>'clientId']
                  , scopes: Array.from(oktaSettings[<any>'scopes'])
                  , pkce: JSON.parse(oktaSettings[<any>'pkce'])
                };
                const oktaAuth = new OktaAuth(oktaConfig);
                return { oktaAuth };
              }
              , deps: ['CONFIG_SETTINGS']
            }
            , {
              provide: HTTP_INTERCEPTORS
              , useClass: InterceptorDateHttp
              , multi: true
            }
            , {
              provide: HTTP_INTERCEPTORS
              , useClass: LoaderInterceptor
              , multi: true
            }
            , {
              provide: HTTP_INTERCEPTORS
              , useClass: ErrorIntercept
              , multi: true
            }
            , {
              provide: APP_INITIALIZER
              , useFactory: initSettingsTabs
              , deps: [UserService]
              , multi: true
            }
            , {
              provide: ErrorHandler
              , useClass: ApplicationInsightsErrorHandler
            }
            , provideHttpClient(withInterceptorsFromDi())
            , provideAnimations()
            , UiWindowService
            , NotificationService
            , ConfirmationDialogService
            , ConfirmationDialogHtmlPaneService
            , LicenseServiceGrid
            , RoleTemplateServiceGrid
            , provideLottieOptions({
              player:()=>import('lottie-web')
            })
            , provideRouter([
              { path: '', redirectTo: 'login', pathMatch: 'full' }
              , { path: 'home', component: HomePageComponent, canActivate: [OktaAuthGuard] }
              , { path: 'login', component: LoginComponent }
              , { path: 'login/callback', component: OktaCallbackComponent }
              , {
                path: 'admin'
                , loadChildren: () => import('./app/features/admin/admin.routes')
                  .then((r => r.ADMIN_ROUTES))
              },
              {
                path: 'userManagement'
                , loadChildren: () => import('./app/features/userManagement/um.routes')
                  .then((r => r.UM_ROUTES))
              }
              //, {
              //  path: 'deals'
              //  , loadChildren: () => import('./app/features/prob/prob-deals.routes')
              //    .then((r => r.PROB_DEALS_ROUTES))
              //}
              , { path: 'error/404', component: PageNotFoundComponent }
              , { path: 'error/not-authorized', component: PageNotAuthorizedComponent }
              , { path: 'not-authorized', redirectTo: 'error/not-authorized' }
              , { path: 'no-license', component: PageNoLicenseComponent }
              , { path: '**', redirectTo: 'error/404' }
            ])
          ]
        })
        .catch(err => console.log(err));

    })
